import React from 'react';
import { 
  FaFile, 
  FaFolder, 
  FaImage, 
  FaVideo, 
  FaMusic, 
  FaFilePdf, 
  FaFileWord, 
  FaFileExcel, 
  FaFilePowerpoint, 
  FaFileArchive, 
  FaFileCode,
  FaFileAlt
} from 'react-icons/fa';
import { getFileType, isFolder } from '../utils/fileUtils';
import LazyImage from './LazyImage';

const FileIcon = ({ fileName, itemType, size = "text-3xl", className = "", showThumbnail = true }) => {
  const iconClassName = `${size} ${className}`;
  
  // Obtener tipo de archivo
  const fileType = getFileType(fileName);
  const itemIsFolder = itemType === 'folder' || isFolder({ Key: fileName, type: itemType });
  
  // Si es una carpeta
  if (itemIsFolder) {
    return <FaFolder className={`${iconClassName} text-gray-300`} />;
  }
  
  // Si es una imagen y queremos mostrar thumbnail, usar LazyImage
  if (fileType === 'image' && showThumbnail && fileName) {
    return (
      <LazyImage 
        fileName={fileName}
        alt={fileName}
        className="w-full h-48"
        width={200}
        height={150}
        quality={40}
      />
    );
  }
  
  switch (fileType) {
    case 'image':
      return <FaImage className={`${iconClassName} text-green-500`} />;
    case 'video':
      return <FaVideo className={`${iconClassName} text-red-500`} />;
    case 'audio':
      return <FaMusic className={`${iconClassName} text-purple-500`} />;
    case 'document':
      // Específico para PDF
      if (fileName?.toLowerCase().endsWith('.pdf')) {
        return <FaFilePdf className={`${iconClassName} text-red-600`} />;
      }
      // Word documents
      if (fileName?.toLowerCase().match(/\.(doc|docx)$/)) {
        return <FaFileWord className={`${iconClassName} text-blue-600`} />;
      }
      return <FaFileAlt className={`${iconClassName} text-blue-400`} />;
    case 'spreadsheet':
      return <FaFileExcel className={`${iconClassName} text-green-600`} />;
    case 'presentation':
      return <FaFilePowerpoint className={`${iconClassName} text-orange-600`} />;
    case 'archive':
      return <FaFileArchive className={`${iconClassName} text-yellow-600`} />;
    case 'code':
      return <FaFileCode className={`${iconClassName} text-cyan-500`} />;
    default:
      return <FaFile className={`${iconClassName} text-gray-400`} />;
  }
};

export default FileIcon; 